/**
 * ## RPC action for embedded API calls
 *
 * @module src/controllers/rpc
 */

"use strict";

const layout = require("../../components/layout");
const tabs = require("../../controllers/tabs");
const chart = require("../../components/chart");

let ready = false;

/** Init
 */
const init = (kd) => {
  const receiveMessage = (event) => {
    switch (event.data.type) {
      case "config":
        switch (event.data.action) {
          case "guestlist_config":
            process("config", event.data.payload, kd);
            setTimeout(() => {
              if (!ready) {
                ready = true;
                kd.emit("ready", {});
              }
            }, 1);
            break;
          default:
            break;
        }
        break;
      case "order":
        switch (event.data.action) {
          case "open_orders":
            process("orders", event.data.payload, kd);
            break;
          default:
            break;
        }
        break;
      case "rpc":
        switch (event.data.action) {
          case "select_table":
            layout.embed(0.2);
            if (
              event.data.hasOwnProperty("options") &&
              event.data.options.hasOwnProperty("size") &&
              !isNaN(event.data.options.size)
            ) {
              chart.setEmbedOverflow(true, event.data.options.size);
            } else {
              chart.setEmbedOverflow(true, 1);
            }
            break;
          case "default":
            layout.embed(0.2);
            kd.localstore.data.chart_status_filter = 0;
            kd.emit("chart.update", {});
            chart.setEmbedOverflow(false, 2);
            break;
          case "default_section":
            tabs.tab(kd, "sections");
            layout.embedExpanded(0.2);
            if (
              event.data.hasOwnProperty("options") &&
              event.data.options.hasOwnProperty("section") &&
              event.data.options.section
            ) {
              const opt = {
                section: event.data.options.section,
              };
              chart.zoom(kd, opt);
            }
            break;
          case "default_filter":
            // tabs.tab('filter');
            layout.embed(0.2);
            chart.setEmbedOverflow(false, 2);
            if (
              event.data.hasOwnProperty("options") &&
              event.data.options.hasOwnProperty("state") &&
              event.data.options.state
            ) {
              let tableStatus = 0;
              switch (event.data.options.state) {
                case "all":
                  tableStatus = 0;
                  break;
                case "open":
                  tableStatus = 1;
                  break;
                case "seated":
                  tableStatus = 2;
                  break;
                case "ordered":
                  tableStatus = 3;
                  break;
                case "printed":
                  tableStatus = 4;
                  break;
                case "paid":
                  tableStatus = 5;
                  break;
                case "dirty":
                  tableStatus = 6;
                  break;
                default:
                  break;
              }
              kd.localstore.data.chart_status_filter = tableStatus;
              kd.emit("chart.update", {});
            }
            break;
          case "reset_zoom":
            layout.embed(0.2);
            chart.resetZoom(kd);
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  };

  window.addEventListener("message", receiveMessage, false);

  kd.on("rpc", (data) => {
    window.parent.postMessage(data, "*");
  });

  kd.on("push", (data) => {
    const location = data;
    const chart2 = kd.doc("chart")[0];
    const limit = kd.doc("limit");
    const template = kd.find("template", {
      $and: [{ active: 1 }, { chart: location.chart }],
    });
    let pushData = {};
    switch (data.domain) {
      case "location":
      case "chart":
      case "limit":
      case "template":
        pushData = {
          type: "push",
          action: "config",
          options: {},
          payload: {
            location,
            chart2,
            limit,
            template,
          },
        };
        break;
      default:
        pushData = {
          type: "push",
          action: data.domain,
          options: {},
          payload: data,
        };
        break;
    }

    window.parent.postMessage(pushData, "*");
  });

  window.parent.postMessage({ type: "ready" }, "*");
};

const process = (domain, payload, kd) => {
  // only orders and config exist now
  switch (domain) {
    case "orders": {
      const activity = xenial2guestlist(payload, kd);
      kd.replace("activity", activity);
      setTimeout(() => {
        kd.emit("chart.update", {});
      }, 10);

      break;
    }
    case "config": {
      Object.keys(payload).forEach((domain2) => {
        kd.replace(domain2, payload[domain2]);
      });
      setTimeout(() => {
        kd.emit("location.update", {});
      }, 10);

      break;
    }
    default:
      break;
  }
};

const xenial2guestlist = (orders, kd) => {
  const activitys = [];
  orders.forEach((order) => {
    let status = 5;
    let tableStatus = 0;
    let join = [];
    const createdWithOffset = new Date(order.time.created);
    const updatedWithOffset = new Date(order.time.last_modified);
    const offset = createdWithOffset.getTimezoneOffset() * 60 * 1000;
    const created = Math.floor((createdWithOffset.getTime() + offset) / 1000);
    const updated = Math.floor((updatedWithOffset.getTime() + offset) / 1000);
    if (order.hasOwnProperty("join") && order.join.length > 0) {
      join = order.join;
    }
    switch (order.state) {
      case "closed":
        status = 5;
        tableStatus = 7;
        break;
      case "open":
        status = 3;
        tableStatus = 2;
        break;
      case "seated":
        status = 3;
        tableStatus = 2;
        break;
      case "ordered":
        status = 3;
        tableStatus = 3;
        break;
      case "printed":
        status = 3;
        tableStatus = 4;
        break;
      case "paid":
        status = 3;
        tableStatus = 5;
        break;
      case "dirty":
        status = 3;
        tableStatus = 6;
        break;
      default:
        break;
    }
    const activity = {
      _id: order._id,
      domain: "activity",
      status,
      tableStatus,
      section: order.section,
      name: order.name,
      total: order.total,
      statusTimes: {
        added: created,
        seated: created,
      },
      size: 2,
      table: order.table,
      join,
      service: "client",
      api: {
        version: "1.0.0",
        type: "embed",
      },
      preference: "",
      waited: 0,
      alerts: 0,
      reserved: 0,
      _kd: {
        type: "embed",
        site_id: kd.localstore.data.credentials.site_id,
        user_id: kd.localstore.data.credentials.user_id,
        room: kd.localstore.data.credentials.room,
        updated,
        created,
      },
    };
    if (order.hasOwnProperty("table_name") && order.table_name) {
      activity.tableName = order.table_name;
    }
    if (order.hasOwnProperty("name") && order.name) {
      activity.name = order.name;
    }
    activitys.push(activity);
  });

  return activitys;
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/rpc/index.js
 **/